import axios from 'axios';
import _ from 'lodash';
import { toast } from 'react-toastify';
import intl from 'react-intl-universal';

import { store } from './get-redux-store';

import { getAuthHttpConfigByToken, dispatchSignOut } from './auth-utils';
import { history } from './history';

const toCamel = obj => {
  if (!_.isObject(obj)) {
    return obj;
  } else if (_.isArray(obj)) {
    return obj.map(v => toCamel(v));
  }
  return _.reduce(
    obj,
    (r, v, k) => {
      return {
        ...r,
        [_.camelCase(k)]: toCamel(v)
      };
    },
    {}
  );
};

let baseURL = '/api';
// let baseURL = 'http://localhost:3000/api';
if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.REACT_APP_API_BASEURL || 'https://app.clickdishes.com.cn/api';
  // baseURL = "https://production.clickdishes.co/api";
}

const instance = axios.create({
  baseURL
});

let authToken = null;

store.subscribe(() => {
  authToken = store.getState().storage.authToken;
});

const logPermissionNotAllowedContext = obj => {
  console.log('Permission not allowed');
};

instance.interceptors.response.use(
  function(response) {
    return toCamel(response);
  },
  function(error) {
    if (error.response.status === 401 && authToken !== undefined) {
      axios
        .get(`${baseURL}/testToken`, getAuthHttpConfigByToken(authToken))
        .then(res => {
          toast.error(intl.get('general.error.permissionNotAllowed'));
          logPermissionNotAllowedContext({
            httpConfig: getAuthHttpConfigByToken(authToken),
            authToken,
            responseData: res.data,
            baseURL
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            dispatchSignOut(store.dispatch);
            history.push('/signin');
          } else {
            return Promise.reject(error);
          }
        });
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;
